import transactions from './transactions'
import payables from './payables'
import search from './search'
import user from './user'
import company from './company'
import companySegments from './companySegments'
import chargebacks from './chargebacks'
import session from './session'
import invites from './invites'
import splitRules from './splitRules'
import antifraudAnalyses from './antifraudAnalyses'
import recipients from './recipients'
import bulkAnticipations from './bulkAnticipations'
import bankAccounts from './bankAccounts'
import plans from './plans'
import acquirersConfigurations from './acquirersConfigurations'
import acquirers from './acquirers'
import subscriptions from './subscriptions'
import cards from './cards'
import transfers from './transfers'
import balance from './balance'
import balanceOperations from './balanceOperations'
import events from './events'
import gatewayOperations from './gatewayOperations'
import chargebackOperations from './chargebackOperations'
import postbacks from './postbacks'
import security from './security'
import customers from './customers'
import zipcodes from './zipcodes'
import paymentLinks from './paymentLinks'
import pixKeys from './pix'
import status from './status'
import onboardingAnswers from './onboardingAnswers'
import onboardingQuestions from './onboardingQuestions'
import orders from './orders'
import versions from './versions'
import reprocessedTransactions from './reprocessedTransactions'
import refunds from './refunds'
import feePresets from './feePresets'
import settlements from './settlements'
import credit from './credit'

export default {
  company,
  companySegments,
  chargebacks,
  search,
  session,
  transactions,
  payables,
  pixKeys,
  user,
  invites,
  splitRules,
  antifraudAnalyses,
  recipients,
  bulkAnticipations,
  bankAccounts,
  plans,
  subscriptions,
  cards,
  acquirersConfigurations,
  acquirers,
  transfers,
  balance,
  balanceOperations,
  events,
  gatewayOperations,
  chargebackOperations,
  postbacks,
  security,
  customers,
  zipcodes,
  paymentLinks,
  settlements,
  status,
  onboardingAnswers,
  onboardingQuestions,
  orders,
  versions,
  reprocessedTransactions,
  refunds,
  feePresets,
  credit,
}



/** WEBPACK FOOTER **
 ** ./resources/index.js
 **/